module.exports = __webpack_public_path__ + "img/referral-fill.03a0ce31.svg";